import { createStyles } from "@mantine/core";
import { IPaymentFrequencySwitchProps } from "./types";

export const useStyles = createStyles(
  (
    theme,
    {
      disabled,
      withBorder,
    }: Pick<IPaymentFrequencySwitchProps, "disabled" | "withBorder">,
  ) => ({
    card: {
      cursor: disabled ? "default" : undefined,
      opacity: disabled ? theme.other.disabled.opacity : 1,
      pointerEvents: disabled ? "none" : "auto",
      overflow: withBorder ? "hidden" : "unset",
    },
  }),
);
